"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConversationHeader = void 0;

var React = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _ = require("../..");

var _helpers = require("../../helpers");

var _AvatarText = require("./AvatarText");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ConversationDetails = _styledComponents.default.div.withConfig({
  displayName: "ConversationDetails",
  componentId: "sc-18726d3-0"
})(["white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:100%;*{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}"]);

var DateAndNew = _styledComponents.default.div.withConfig({
  displayName: "DateAndNew",
  componentId: "sc-18726d3-1"
})(["display:flex;flex-direction:row;justify-content:space-between;"]);

var LastMessageDate = (0, _styledComponents.default)(function (props) {
  return React.createElement(_.Subtitle2, props);
}).withConfig({
  displayName: "LastMessageDate",
  componentId: "sc-18726d3-2"
})([""]);
var Title = (0, _styledComponents.default)(function (props) {
  return React.createElement(_.Body, props);
}).withConfig({
  displayName: "Title",
  componentId: "sc-18726d3-3"
})(["display:block;"]);
var Company = (0, _styledComponents.default)(function (props) {
  return React.createElement(_.Subtitle, props);
}).withConfig({
  displayName: "Company",
  componentId: "sc-18726d3-4"
})([""]);
var Subject = (0, _styledComponents.default)(function (props) {
  return React.createElement(_.Subtitle, props);
}).withConfig({
  displayName: "Subject",
  componentId: "sc-18726d3-5"
})([""]);
var ConversationCard = (0, _styledComponents.default)(_.CardSection).withConfig({
  displayName: "ConversationCard",
  componentId: "sc-18726d3-6"
})(["cursor:pointer;display:flex;flex-direction:row;color:", ";position:relative;z-index:1;&:hover{z-index:2;box-shadow:0 4px 12px 1px rgba(43,43,43,0.1);}", " ", ""], (0, _helpers.color)('black'), function (p) {
  return p.newMessages && (0, _styledComponents.css)(["", "{font-weight:", ";}", ",", "{color:", ";}"], _.Body, (0, _helpers.fontWeight)('bold'), _.Subtitle, _.Subtitle2, (0, _helpers.color)('black'));
}, function (p) {
  return p.isSelected && (0, _styledComponents.css)(["background:", ";", "{color:", ";}", ",", "{font-weight:", ";color:", ";}"], (0, _helpers.color)('primary'), _.Body, (0, _helpers.color)('white'), _.Subtitle, _.Subtitle2, (0, _helpers.fontWeight)('regular'), (0, _helpers.color)('white'));
});

var companyInitials = function companyInitials(companyName) {
  return companyName.split(' ').map(function (part) {
    return part[0];
  }).join('').slice(0, 2).toUpperCase();
};

var ConversationHeader = function ConversationHeader(_ref) {
  var applicationId = _ref.applicationId,
      title = _ref.title,
      company = _ref.company,
      subject = _ref.subject,
      latestMessageDate = _ref.latestMessageDate,
      handleClick = _ref.handleClick,
      newMessages = _ref.newMessages,
      isSelected = _ref.isSelected;
  return React.createElement(ConversationCard, {
    key: applicationId,
    newMessages: newMessages,
    isSelected: isSelected,
    onClick: function onClick() {
      return handleClick(applicationId);
    }
  }, React.createElement(_AvatarText.AvatarText, {
    isReversed: isSelected,
    isSender: true
  }, companyInitials(company)), React.createElement(ConversationDetails, null, React.createElement(DateAndNew, null, React.createElement(LastMessageDate, null, latestMessageDate), newMessages && React.createElement(_.Chip, {
    chipStyle: "info"
  }, newMessages > 1 && "".concat(newMessages, " "), "New")), React.createElement(Title, null, title), React.createElement(Company, null, company), React.createElement(Subject, null, subject)));
};

exports.ConversationHeader = ConversationHeader;